import { DataType } from '@inpart-io/padme-iap';
import { type IInfoGroup } from '@inpart-io/padme-iap';

export const assetProfilesTypes = [DataType.LeadProfile];

export const assetProfileDataTypes = [
    DataType.LeadAssetProfile,
    DataType.LeadTechnologyProfile,
    DataType.LeadConsumerHealthProfile,
    DataType.LeadCompanyProfile
];

type ContainerTypeForInfoGroup = Partial<Pick<IInfoGroup, 'forClassName'>>;

export function useInfoGroupClassName(): {
    isForLeadAssetProfile: (infogroup: ContainerTypeForInfoGroup) => boolean;

    getInfoGroupAttributeContainer: (infogroup?: ContainerTypeForInfoGroup) => string;
} {
    const isForLeadAssetProfile = (infogroup?: ContainerTypeForInfoGroup): boolean => {
        return assetProfileDataTypes.includes(infogroup.forClassName);
    };
    const isForAssetProfiles = (infogroup?: ContainerTypeForInfoGroup): boolean => {
        return assetProfilesTypes.includes(infogroup.forClassName);
    };
    const isForAgreement = (infogroup?: ContainerTypeForInfoGroup): boolean => {
        return infogroup.forClassName === DataType.AgreementDetail;
    };
    const isForAlliance = (infogroup?: ContainerTypeForInfoGroup): boolean => {
        return infogroup.forClassName === DataType.AllianceDetail;
    };
    const getInfoGroupAttributeContainer = (infogroup?: ContainerTypeForInfoGroup): string => {
        if (isForAgreement(infogroup)) {
            return '@(detail:AgreementDetail:agreement).infogroups';
        } else if (isForAlliance(infogroup)) {
            return ' @(detail:AllianceDetail:alliance).infogroups';
        } else if (isForAssetProfiles(infogroup)) {
            return 'assetProfiles.infogroups';
        }
        return isForLeadAssetProfile(infogroup) ? 'assetProfileEntity.infogroups' : 'infogroups';
    };

    return {
        isForLeadAssetProfile,
        getInfoGroupAttributeContainer
    };
}
